import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorHandler from './errorHandler';
import useDebugHandler from './useDebugHandler';
import { destroyPlayer } from './LearnosityHelpers';

const API_TYPES_MAP = {
  authoring: 'LearnosityAuthor',
  items: 'LearnosityItems',
  assess: 'LearnosityAssess',
  reports: 'LearnosityReports',
  data: null,
};

const useLearnosityProvider = (props) => {
  const {
    apiType,
    initOptions,
    testReadyListener,
    readyListener = () => {},
    errorListener = () => {},
    dataListener = () => {},
    containerElement = 'learnosity_assess',
    className = 'cb-learnosity-player',
    sessionId,
    itemReference,
  } = props;
  const { isDifferentDomain, devLearnosityInit } = useDebugHandler({
    initOptions,
  });
  const [app, setApp] = useState();
  useEffect(() => {
    const _errorListener = (error) => {
      errorListener(error);
      errorHandler(error);
    };

    const apiHandler = API_TYPES_MAP[apiType];

    if (!apiHandler) {
      return;
    }

    const funcHandler = isDifferentDomain
      ? { init: devLearnosityInit }
      : window[apiHandler];
    const _app = funcHandler.init(
      initOptions,
      {
        readyListener: () => readyListener(_app),
        errorListener: (error) => _errorListener(error),
        dataListener: (data) => dataListener(data),
      },
      containerElement,
    );

    if (testReadyListener) {
      _app.on('test:ready', () => testReadyListener(_app));
    }

    setApp(_app);
  }, []);

  const destroyLearnosityApi = () => {
    if (app) {
      destroyPlayer(app);
    }
  };

  const element = containerElement ? (
    <div
      key={1}
      className={className}
      id={containerElement}
      data-session-id={sessionId}
      data-reference={itemReference}
    />
  ) : null;

  return { element, app, destroyLearnosityApi };
};

useLearnosityProvider.propTypes = {
  apiType: PropTypes.string.isRequired,
  initOptions: PropTypes.object.isRequired,
};

export default useLearnosityProvider;
